export const SEEN_POINTER_IDS: Set<number> = new Set();
